export function encrypt(str = '') {
  return String.fromCharCode(...(str.split('').map(c => c.charCodeAt(0) + 1)));
}

